import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=012e5473&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012e5473",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('012e5473')) {
      api.createRecord('012e5473', component.options)
    } else {
      api.reload('012e5473', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=012e5473&scoped=true&", function () {
      api.rerender('012e5473', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2N6jo8SCr4F4R/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports